import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=6653312f&scoped=true&"
import script from "./switch.vue?vue&type=script&lang=ts&"
export * from "./switch.vue?vue&type=script&lang=ts&"
import style0 from "./switch.vue?vue&type=style&index=0&id=6653312f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6653312f",
  null
  
)

export default component.exports